import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/appDevLeftImg.png";
import rightimgs from "../../../assets/appDevRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
// import appDevBenefitsImg1 from "../../../assets/appDevBenefitsImg1.png";
// import appDevBenefitsImg2 from "../../../assets/appDevBenefitsImg2.png";
// import appDevBenefitsImg3 from "../../../assets/appDevBenefitsImg3.png";
// import appDevBenefitsImg4 from "../../../assets/appDevBenefitsImg4.png";
// import appDevBenefitsImg5 from "../../../assets/appDevBenefitsImg5.png";
// import appDevBenefitsImg6 from "../../../assets/appDevBenefitsImg6.png";
// import appDevBenefitsImg7 from "../../../assets/appDevBenefitsImg7.png";
// import appDevBenefitsImg8 from "../../../assets/appDevBenefitsImg8.png";
// import appDevBenefitsImg9 from "../../../assets/appDevBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
// import appDevFunActivitiesImg1 from "../../../assets/appDevFunActivitiesImg1.png";
// import appDevFunActivitiesImg2 from "../../../assets/appDevFunActivitiesImg2.png";
// import appDevFunActivitiesImg3 from "../../../assets/appDevFunActivitiesImg3.png";
// import appDevFunActivitiesImg4 from "../../../assets/appDevFunActivitiesImg4.png";
// import appDevFunActivitiesImg5 from "../../../assets/appDevFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

const AndroidAppDevPortal = () => {
  const appdevpage = heroContent.androidappdevpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "OOP Concepts Master Java basics, classes, inheritance & exceptions.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "Android App Build simple apps with Activities, Views & Layouts.",
    },
    {
      title: "Module 3",
      activities: "6",
      classes: "3",
      description:
        "User Interaction Add inputs, navigation, dialogs & gestures.",
    },
    {
      title: "Module 4",
      activities: "6",
      classes: "3",
      description:
        "Delightful UI Design stylish UIs with themes, motion & testing.",
    },
    {
      title: "Module 5",
      activities: "6",
      classes: "3",
      description: "Services Add internet, alarms & background tasks.",
    },
    {
      title: "Module 6",
      activities: "10",
      classes: "5",
      description: "Firebase Create real apps with login, database & storage.",
    },
  ];

  const benefitsData = [
    {
      title: "Master OOP Concepts",
      description: "Learn Classes, Objects, Inheritance, and Polymorphism.",
      icon: "Polymath-images/appDevBenefitsImg1.png",
    },
    {
      title: "Boost Code Efficiency",
      description: "Use Inheritance and Polymorphism for maintainable code.",
      icon: "Polymath-images/appDevBenefitsImg2.png",
    },
    {
      title: "Build Robust Apps",
      description: "Implement Exception Handling for error-free apps.",
      icon: "Polymath-images/appDevBenefitsImg3.png",
    },
    {
      title: "Design Interactive UI",
      description: "Master Views, Layouts, and Resources for responsive UI.",
      icon: "Polymath-images/appDevBenefitsImg4.png",
    },
    {
      title: "Seamless Navigation",
      description: "Manage Activities and Intents for smooth app flow.",
      icon: "Polymath-images/appDevBenefitsImg5.png",
    },
    {
      title: "Advanced User Interaction",
      description: "Use Recycler Views, Dialogs, and Gestures.",
      icon: "Polymath-images/appDevBenefitsImg6.png",
    },
    {
      title: "Integrate Firebase",
      description: "Manage data with Firebase for real-time apps.",
      icon: "Polymath-images/appDevBenefitsImg7.png",
    },
    {
      title: "Test for Quality",
      description:
        "Ensure reliable, bug-free app experiences through effective testing.",
      icon: "Polymath-images/appDevBenefitsImg8.png",
    },
    {
      title: "Master Background Tasks",
      description:
        "Use Job Scheduler and Alarm Manager for seamless app performance.",
      icon: "Polymath-images/appDevBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Scrolling Text App",
      image: "Polymath-images/appDevFunActivitiesImg1.png",
    },
    {
      title: "Counter App",
      image: "Polymath-images/appDevFunActivitiesImg2.png",
    },
    {
      title: "Food Ordering App",
      image: "Polymath-images/appDevFunActivitiesImg3.png",
    },
    {
      title: "Alarm Manager",
      image: "Polymath-images/appDevFunActivitiesImg4.png",
    },
    {
      title: "Dictionary App",
      image: "Polymath-images/appDevFunActivitiesImg5.png",
    },
  ];

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={"Polymath-images/appDevLeftImg.png"}
      rightImg={'Polymath-images/appDevRightImg.png'}
      titlePart1="Android App Development"
      titlePart2="Course"
      description="Polymath-Kids App Development Program for kids is a comprehensive course which enables them to develop and publish their own interesting and creative Apps. There are countless career opportunities for individuals proficient in app development essentials. Learning to code at an early age can help learners become experts and reap the benefits provided by technology.

"
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Android App Develpment"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn App Development"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default AndroidAppDevPortal;
